import React from 'react'
import { useLocation } from 'react-router-dom'

function DeclarationNotFoundPage() {
  const { state } = useLocation()

  return (<div>{`Declaration ${state?.id} not found`}</div>)
}

export default DeclarationNotFoundPage
